import React from 'react'
import { FaBars, FaFacebook, FaInstagram } from 'react-icons/fa';
import { scrollToTop, scrollToSection } from '../../utils/scrollUtils';
import image from '../../images/logo.png';
import { useTranslation } from 'react-i18next';


import { 
    Nav, 
    NavbarContainer, 
    NavLogo, 
    HeroLogo, 
    MobileIcon, 
    NavMenu, 
    NavItem, 
    NavLinks,
    NavRedes,
    NavRedesLink
} from './NavbarElements';


const Navbar = ({ toggle }) => {
  const [activeSection, setActiveSection] = React.useState(null);
  const { t } = useTranslation();


  const sections = [
  { id: 'historia', label: t('nav.historia') },
  { id: 'ambiente', label: t('nav.ambiente') },
  { id: 'culinaria', label: t('nav.culinaria') },
  { id: 'fotos', label: t('nav.fotos') },
  { id: 'cardapio', label: t('nav.menu') }
];




  React.useEffect(() => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    }, options);

    sections.forEach(sec => {
      const el = document.getElementById(sec.id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Nav className='navbar'>
        <NavbarContainer>
          
          <NavLogo onClick={scrollToTop}>
            <HeroLogo src={image}/>
          </NavLogo>

          <MobileIcon onClick={toggle}>
            <FaBars />
          </MobileIcon>

          <NavMenu>
            {sections.map((sec) => (
              <NavItem key={sec.id}>
                <NavLinks
                  className={activeSection === sec.id ? 'active' : ''}
                  onClick={() => scrollToSection(sec.id, 80, .8)}
                >
                  {sec.label}
                </NavLinks>
              </NavItem>
            ))}
          </NavMenu>

          <NavRedes>
            <NavRedesLink target="blank" to="https://www.facebook.com/varandasbonitoms/">
              <FaFacebook />
            </NavRedesLink>
            <NavRedesLink target="blank" to="https://www.instagram.com/varandasbonitoms">
              <FaInstagram />
            </NavRedesLink>
          </NavRedes>

        </NavbarContainer>
      </Nav>
    </>
  )
}

export default Navbar;
